/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.technicianLocation[_ngcontent-%COMP%]{height:200px}.subtitle[_ngcontent-%COMP%]{font-size:20px}.padding[_ngcontent-%COMP%]{padding-left:11px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL2F0dGVuZGluZy9jb21wb25lbnQvdGVjaG5pY2lhbi1sb2NhdGlvbi90ZWNobmljaWFuLWxvY2F0aW9uLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9qZW5raW5zL3dvcmtzcGFjZS9wcm9kdWN0aW9uLWFyZ29zLWZyb250L2FyZ29zL3NyYy9hcHAvYXR0ZW5kaW5nL2NvbXBvbmVudC90ZWNobmljaWFuLWxvY2F0aW9uL3RlY2huaWNpYW4tbG9jYXRpb24uY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/attending/component/technician-location/technician-location.component.css.shim.ngstyle.ts